module.exports = __webpack_public_path__ + "img/thumbfield4.aec32010.png";